// extracted by mini-css-extract-plugin
export default {"root":"SearchSelect_root__-gqK3","hasFocus":"SearchSelect_hasFocus__pdh93","suggestions":"SearchSelect_suggestions__8B4P1"};